import { render, staticRenderFns } from "./StoreBlackList.vue?vue&type=template&id=55733409&"
import script from "./StoreBlackList.vue?vue&type=script&lang=js&"
export * from "./StoreBlackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports